import React, { useEffect, useState } from "react";
import "./FilterTraderComponent.css";
import Select from "react-select";

let Intervals = [
  {
    label: "Time",
    key: "time",
    values: ["block", "date"],
    isTime: true,
  },
  {
    label: "Date",
    key: "date",
    values: ["date"],
    isTime: false,
  },
  {
    label: "Month",
    key: "month",
    values: ["month"],
    isTime: false,
  },
];

const TABS = ["Chart", "Table"];

const FilterTraderComponent = ({
  data,
  handleFilterData,
  handleSelectFilter,
  filterType,
  selectedTab,
  setSelectedTab,
}) => {
  const [selectedTabs, setSelectedTabs] = useState(["buy", "sell"]);
  const [selectedFilters, setSelectedFilters] = useState({
    trader: "",
    name: "",
    state: "",
    category: "",
    product: "",
    transaction_type: "",
    time_block: "",
    selectedInterval: Intervals[0].key,
  });
  const [filters, setFilters] = useState([]);

  const [names, setNames] = useState([]);
  const [states, setStates] = useState([]);
  const [categories, setCategories] = useState([]);
  const [areTabsEnabled, setAreTabsEnabled] = useState(false);
  const [selectedInterval, setSelectedInterval] = useState(filterType);

  useEffect(() => {
    setSelectedFilters((prevFilters) => ({
      ...prevFilters,
      selectedInterval: selectedInterval.key,
    }));
  }, [selectedInterval]);

  const handleIntervalChange = (interval) => {
    setSelectedInterval(interval);
    handleFilterData({ ...selectedFilters, selectedInterval: interval.key });
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      width: "190px",
      backgroundColor: "white",
      height: "35px",
      minHeight: "35px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "8px",
      fontSize: "12px",
      fontWeight: "450",
      zIndex: "1",
      border: state.isFocused
        ? "1px solid rgba(0, 0, 0, 0.87)"
        : "1px solid rgba(0, 0, 0, 0.23)",
      boxShadow: state.isFocused ? "0 0 5px rgba(0, 0, 0, 0.2)" : "none",
      "&:hover": {
        borderColor: "rgba(0, 0, 0, 0.87)",
      },
    }),
    menu: (provided) => ({
      ...provided,
      fontSize: "14px",
      zIndex: "1",
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: "14px",
      zIndex: "1",

      backgroundColor: state.isSelected ? "#F1935C" : "white",
      color: state.isSelected ? "white" : "black",
      "&:hover": {
        backgroundColor: "#f1935c",
        color: "white",
      },
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: "12px",
      fontWeight: "400",
      color: "#8C8A96",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }),
  };

  const options =
    filters?.product?.map((option) => ({
      value: option,
      label: option,
    })) || [];

  const transactionTypeOptions =
    filters?.transaction_type?.map((option) => ({
      value: option,
      label: option,
    })) || [];

  const traderOptions =
    filters?.trader?.map((option) => ({
      value: option,
      label: option,
    })) || [];

 
  const nameOptions = names.map((name) => ({ label: name, value: name }));
  const stateOptions = states.map((state) => ({ label: state, value: state }));
  const categoryOptions = categories.map((category) => ({
    label: category,
    value: category,
  }));

  // useEffect(() => {
  //   fetchFilters();
  //   if (filters) {
  //     mergeFilters();
  //   }
  // }, []);

  useEffect(() => {
    fetchFilters();
  }, []);

  useEffect(() => {
    if (Intervals.length > 0) {
      setSelectedInterval(Intervals[0]);
    }
  }, []);

  useEffect(() => {
    if (filters && Object.keys(filters).length > 0) {
      mergeFilters();
    }
  }, [filters]);

  // useEffect(() => {
  //   handleFilterData(selectedFilters);
  // }, [selectedFilters]);

  useEffect(() => {
    let updatedFilters = { ...selectedFilters };
  
    if (selectedTabs.includes("buy") && selectedTabs.includes("sell")) {
      updatedFilters = {
        ...updatedFilters,
        name_of_buyer: selectedFilters.name_of_buyer,
        name_of_seller: selectedFilters.name_of_seller,
        category_of_buyer: selectedFilters.category_of_buyer,
        category_of_seller: selectedFilters.category_of_seller,
        state_of_buyer: selectedFilters.state_of_buyer,
        state_of_seller: selectedFilters.state_of_seller,
      };
    } else if (selectedTabs.includes("buy")) {
      updatedFilters = {
        ...updatedFilters,
        name_of_buyer: selectedFilters.name,
        name_of_seller: "",
        category_of_buyer: selectedFilters.category,
        category_of_seller: "",
        state_of_buyer: selectedFilters.state,
        state_of_seller: "",
      };
    } else if (selectedTabs.includes("sell")) {
      updatedFilters = {
        ...updatedFilters,
        name_of_buyer: "",
        name_of_seller: selectedFilters.name,
        category_of_buyer: "",
        category_of_seller: selectedFilters.category,
        state_of_buyer: "",
        state_of_seller: selectedFilters.state,
      };
    } else {
      updatedFilters = {
        ...updatedFilters,
        name_of_buyer: "",
        name_of_seller: "",
        category_of_buyer: "",
        category_of_seller: "",
        state_of_buyer: "",
        state_of_seller: "",
      };
    }
  
    handleFilterData(updatedFilters);
  }, [selectedFilters, selectedTabs]);
  

  async function fetchFilters() {
    try {
      const res = await fetch(
        "https://api-data.gna.energy/data/getUniqueTradingBlockFilterParameters"
      );
      if (!res.ok) {
        throw new Error("Failed to fetch filters");
      }
      const result = await res.json();
      setFilters(result);
    } catch (error) {
      console.error("Error fetching filters:", error);
    }
  }

  useEffect(() => {
    const hasRequiredFilter =
      selectedFilters.name !== "" ||
      selectedFilters.state !== "" ||
      selectedFilters.category !== "";

    setAreTabsEnabled(hasRequiredFilter);

    if (!hasRequiredFilter && selectedTabs.length !== 2) {
      setSelectedTabs(["buy", "sell"]);
    }
  }, [
    selectedFilters.name,
    selectedFilters.state,
    selectedFilters.category,
    selectedTabs.length,
  ]);

  const mergeFilters = () => {
    if (!filters) return;
    const uniqueNames = [
      ...new Set([
        ...(filters.name_of_seller || []),
        ...(filters.name_of_buyer || []),
      ]),
    ];
    const uniqueStates = [
      ...new Set([
        ...(filters.state_of_seller || []),
        ...(filters.state_of_buyer || []),
      ]),
    ];
    const uniqueCategories = [
      ...new Set([
        ...(filters.category_of_seller || []),
        ...(filters.category_of_buyer || []),
      ]),
    ];

    setNames(uniqueNames);
    setStates(uniqueStates);
    setCategories(uniqueCategories);
  };

  const handleChange = ({ target }) => {
    let name = target?.name;
    let value = target?.value;
    setSelectedFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value || "",
    }));
    // try {
    //   const filteredResults = data.filter((item) => {
    //     return Object.entries(selectedFilters).every(
    //       ([key, filterValue]) =>
    //         filterValue === "" || item[key] === filterValue
    //     );
    //   });
    //   console.log(filteredResults)
    //   // handleFilterData(filteredResults);
    // } catch (error) {
    //   console.error("Error filtering data:", error);
    // }
  };

  const handleTabClick = (tab) => {
    if (!areTabsEnabled) return;

    if (selectedTabs.includes(tab)) {
      if (selectedTabs.length === 1) return;
      setSelectedTabs(selectedTabs.filter((item) => item !== tab));
    } else {
      setSelectedTabs([...selectedTabs, tab]);
    }
  };

  const handleDate_time_block = (value) => {
    handleSelectFilter(value);
    setSelectedInterval(value);
  };

  return (
    <div className="filterTraderContainer">
      <div className="filterTraderMain">
        <div className="filterTraderSubContNew">
          

          <div className="filterTraderSubCont" >
            <div className="selectButton" id="traderTabs">
              {["Chart", "Table"].map((tab, index) => (
                <div
                
                  onClick={() => setSelectedTab(tab)}
                  style={{
                    borderRadius:
                      index === 0
                        ? "8px 0px 0px 8px"
                        : index === 1
                        ? "0px 8px 8px 0px"
                        : undefined,
                    height: "34px",
                  }}
                  className={
                    selectedTab === tab ? "fiterActive" : "fiterInactive"
                  }
                >
                  {tab}
                </div>
              ))}
            </div>
          </div>

          {/* Trader  */}
          {selectedTab === "Table" && (
          <div className="filterTraderSubCont">
            <Select
              className="filter-sec-name"
              value={
                selectedFilters.trader
                  ? {
                      value: selectedFilters.trader,
                      label: selectedFilters.trader,
                    }
                  : null
              }
              onChange={(selectedOption) =>
                handleChange({
                  target: { name: "trader", value: selectedOption?.value },
                })
              }
              options={traderOptions}
              placeholder="Trader"
              styles={{
                ...customStyles,
                control: (provided) => ({
                  ...provided,
                  width: "110px",
                  height: "35px",
                  minHeight: "35px",
                  borderRadius: "8px",
                }),
                menu: (provided) => ({
                  ...provided,
                  width: "300px",
                }),
                menuList: (provided) => ({
                  ...provided,
                  width: "300px",
                }),
              }}
              isClearable
            />
          </div>
          )}

          {/* Product  */}
          <div className="filterTraderSubCont">
            <Select
              className="filter-sec-name"
              value={
                selectedFilters.product
                  ? {
                      value: selectedFilters.product,
                      label: selectedFilters.product,
                    }
                  : null
              }
              onChange={(selectedOption) =>
                handleChange({
                  target: { name: "product", value: selectedOption?.value },
                })
              }
              options={options}
              placeholder="Product"
              styles={{
                ...customStyles,
                control: (provided) => ({
                  ...provided,
                  width: "110px",
                  height: "35px",
                  minHeight: "35px",
                  borderRadius: "8px",
                }),
                menu: (provided) => ({
                  ...provided,
                  width: "300px",
                }),
                menuList: (provided) => ({
                  ...provided,
                  width: "300px",
                }),
              }}
              isClearable
            />
          </div>

          {/* Transaction Type  */}
          <div className="filterTraderSubCont">
            <Select
              className="filter-sec-name"
              value={
                selectedFilters.transaction_type
                  ? {
                      value: selectedFilters.transaction_type,
                      label: selectedFilters.transaction_type,
                    }
                  : null
              }
              onChange={(selectedOption) =>
                handleChange({
                  target: {
                    name: "transaction_type",
                    value: selectedOption?.value || "",
                  },
                })
              }
              options={transactionTypeOptions}
              placeholder="Transaction Type"
              styles={{
                ...customStyles,
                menu: (provided) => ({
                  ...provided,
                  width: "300px",
                }),
                menuList: (provided) => ({
                  ...provided,
                  width: "300px",
                }),
              }}
              isClearable
            />
          </div>

          {/* Names of buyer and seller  */}
          <div className="filterTraderSubCont">
            <Select
              className="filter-sec-name"
              value={
                selectedFilters.name
                  ? { value: selectedFilters.name, label: selectedFilters.name }
                  : null
              }
              onChange={(selectedOption) =>
                handleChange({
                  target: { name: "name", value: selectedOption?.value },
                })
              }
              options={nameOptions}
              placeholder="Name (Buyer/Seller)"
              styles={{
                ...customStyles,
                control: (provided) => ({
                  ...provided,
                  width: "200px",
                  borderRadius: "8px",
                  height: "35px",
                  minHeight: "35px",
                }),
                menu: (provided) => ({
                  ...provided,
                  width: "300px",
                }),
                menuList: (provided) => ({
                  ...provided,
                  width: "300px",
                }),
              }}
              isClearable
            />
          </div>

          {/* Category of buyer and seller  */}
          <div className="filterTraderSubCont">
            <Select
              className="filter-sec-name"
              value={
                selectedFilters.category
                  ? {
                      value: selectedFilters.category,
                      label: selectedFilters.category,
                    }
                  : null
              }
              onChange={(selectedOption) =>
                handleChange({
                  target: { name: "category", value: selectedOption?.value },
                })
              }
              options={categoryOptions}
              placeholder="Category (Buyer/Seller)"
              styles={{
                ...customStyles,
                control: (provided) => ({
                  ...provided,
                  width: "220px",
                  borderRadius: "8px",
                  height: "35px",
                  minHeight: "35px",
                }),
              }}
              isClearable
            />
          </div>

          {/* States of buyer and seller  */}
          <div className="filterTraderSubCont">
            <Select
              className="filter-sec-name"
              value={
                selectedFilters.state
                  ? {
                      value: selectedFilters.state,
                      label: selectedFilters.state,
                    }
                  : null
              }
              onChange={(selectedOption) =>
                handleChange({
                  target: { name: "state", value: selectedOption?.value },
                })
              }
              options={stateOptions}
              placeholder="State (Buyer/Seller)"
              styles={customStyles}
              isClearable
            />
          </div>
        </div>
        <div className="filterTraderSubCont2">
        {selectedTab === "Chart" && (
          <div id="trader_intervals" className="filterTraderSubCont">
            <div className="intervalTabs">
              {Intervals.map((interval) => (
                <div
                  key={interval.key}
                  onClick={() => handleDate_time_block(interval)}
                  className={`intervalTab ${
                    selectedInterval.key === interval.key
                      ? "active_interavl_tab"
                      : ""
                  }`}
                >
                  {interval.label}
                </div>
              ))}
            </div>
          </div>
        )}
          <div className="tabContainer">
            <button
              onClick={() => handleTabClick("buy")}
              className={`tabButton ${
                selectedTabs.includes("buy") ? "active" : ""
              } ${!areTabsEnabled ? "disabled" : ""}`}
              disabled={!areTabsEnabled}
            >
              Buy
            </button>
            <button
              onClick={() => handleTabClick("sell")}
              className={`tabButtonSell ${
                selectedTabs.includes("sell") ? "active" : ""
              } ${!areTabsEnabled ? "disabled" : ""}`}
              disabled={!areTabsEnabled}
            >
              Sell
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterTraderComponent;
